<template>
  <div id="qwTools">
    <VanConfigProvider theme-vars-scope="global">
      <router-view v-slot="{ Component }">
        <keep-alive :include="cacheKeyList">
          <component :is="Component" v-if="route.meta.keepAlive" />
        </keep-alive>

        <component :is="Component" v-if="!route.meta.keepAlive" />
      </router-view>
    </VanConfigProvider>
  </div>
</template>

<script setup>
const cacheKeyList = [];

initViewPort();
function initViewPort() {
  const metaViewport = document.createElement('meta');
  metaViewport.name = 'viewport';
  metaViewport.content = 'width=device-width, initial-scale=1.0, maximum-scale=1, viewport-fit=cover';
  document.head.appendChild(metaViewport);
}

const route = useRoute();
</script>

<style lang="scss" scoped>
#qwTools {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;

  .van-config-provider {
    width: 100%;
    height: 100%;
  }
}
</style>
